import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiStar, FiArrowRight } = FiIcons;

const TestimonialsSection = () => {
  const testimonials = [
    {
      text: "Me sentía estancada, hoy tengo una nueva versión de mí.",
      author: "María P.",
      rating: 5
    },
    {
      text: "Bajé 6 kg, pero lo más importante es que sané mi relación con la comida.",
      author: "Javier G.",
      rating: 5
    },
    {
      text: "Nunca había hecho nada igual. Esto no es una dieta, es un antes y después.",
      author: "Luisa F.",
      rating: 5
    }
  ];

  const renderStars = (rating) => {
    return Array.from({ length: rating }, (_, i) => (
      <SafeIcon key={i} icon={FiStar} className="text-yellow-400 text-sm fill-current" />
    ));
  };

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-6xl mx-auto"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 text-center mb-12">
            Historias Reales de Transformación
          </h2>
          
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            {testimonials.map((testimonial, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                className="bg-gradient-to-br from-blue-50 to-purple-50 p-8 rounded-2xl shadow-lg border border-blue-100"
              >
                <div className="flex gap-1 mb-4">
                  {renderStars(testimonial.rating)}
                </div>
                <blockquote className="text-gray-700 mb-4 italic text-lg">
                  "{testimonial.text}"
                </blockquote>
                <footer className="text-blue-600 font-semibold">
                  — {testimonial.author}
                </footer>
              </motion.div>
            ))}
          </div>
          
          <div className="text-center">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-green-600 text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-green-700 transition-colors flex items-center gap-2 mx-auto shadow-lg"
            >
              ¡Empieza tu transformación hoy!
              <SafeIcon icon={FiArrowRight} className="text-xl" />
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default TestimonialsSection;